// Long-form, topic-aware article content so every blog page reaches ~1000 words.
// Sections are generated per post (title + category) and localized (de/en/fr/it).

const categoryOf = (post) => {
  const s = post.slug;
  if (s.includes('ski')) return 'ski';
  if (s.includes('chauffeur') || s.includes('limousine') || s.includes('geschaeft')) return 'business';
  if (s.includes('bern') || s.includes('genf') || s.includes('basel') || s.includes('luzern')) return 'route';
  return 'airport';
};

const wordCount = (sections) =>
  sections.reduce((n, sec) => n + sec.paras.join(' ').split(/\s+/).length, 0);

/* ---------------- German ---------------- */
const de = (t, cat) => {
  const base = [
    {
      h: 'Warum sich eine Vorausbuchung lohnt',
      paras: [
        `Wer „${t}" plant, profitiert von einer Buchung im Voraus gleich mehrfach. Sie sichern sich einen garantierten Festpreis, den Sie bereits vor der Fahrt kennen – unabhängig von Verkehr, Tageszeit oder Wartezeit am Flughafen. So gibt es am Ende der Fahrt keine Überraschungen und kein hektisches Suchen nach einem freien Taxi am Terminal.`,
        `Bei einer Vorausbuchung ordnen wir Ihnen einen erfahrenen Chauffeur zu, der die Region kennt, Ihren Flug im Auge behält und pünktlich bereitsteht. Gerade in der Hauptsaison, an Wochenenden oder zu Stosszeiten ist das der Unterschied zwischen entspanntem Reisen und langem Warten.`,
      ],
    },
    {
      h: 'Was im Festpreis alles enthalten ist',
      paras: [
        `Unser Festpreis ist wirklich all-inclusive. Enthalten sind ein professioneller, ortskundiger Chauffeur, ein modernes und gepflegtes Fahrzeug, die automatische Flugverfolgung, kostenlose Wartezeit, Meet & Greet mit Namensschild in der Ankunftshalle sowie Gratis-Wasser und WLAN an Bord. Ein Kindersitz steht auf Wunsch kostenlos bereit.`,
        `Es gibt keine versteckten Zuschläge für Nachtfahrten, Feiertage oder zusätzliches Gepäck. Der Preis, den Sie bei der Buchung sehen, ist der Preis, den Sie bezahlen – transparent und fair. Bei einer Rückfahrt können Sie beide Strecken bequem in einem Vorgang buchen.`,
      ],
    },
    {
      h: 'So berechnen sich die Preise',
      paras: [
        `Der Preis für „${t}" setzt sich aus einem Grundtarif und einem distanzabhängigen Kilometerpreis zusammen. Je nach gewählter Fahrzeugklasse – von der komfortablen Economy-Limousine bis zur luxuriösen Mercedes S-Klasse oder dem geräumigen Van – variiert der Tarif. Grössere Fahrzeuge mit mehr Platz für Passagiere und Gepäck kosten entsprechend etwas mehr.`,
        `Für längere Strecken in die Berge oder in andere Kantone lohnt sich der private Transfer besonders, weil Sie ohne Umsteigen und Wartezeiten direkt an Ihr Ziel gelangen. Nutzen Sie unseren Online-Rechner, um den exakten Festpreis für Ihre Route in Sekunden zu erhalten.`,
      ],
    },
  ];

  const catSection = {
    airport: {
      h: 'Ankunft und Abholung am Flughafen Zürich',
      paras: [
        `Nach der Landung folgen Sie einfach den Schildern zur Ankunftshalle. Dort erwartet Sie Ihr Chauffeur mit einem Namensschild – Sie müssen sich um nichts kümmern. Verspätet sich Ihr Flug, passen wir die Abholung dank Echtzeit-Flugverfolgung automatisch an, ohne Zusatzkosten.`,
        `Für den Rückweg zum Flughafen berechnen wir die ideale Abholzeit anhand Ihrer Abflugzeit und der aktuellen Verkehrslage, damit Sie stressfrei und rechtzeitig zum Check-in kommen. Wir empfehlen, bei europäischen Flügen rund zwei und bei Interkontinentalflügen rund drei Stunden vor Abflug am Flughafen zu sein.`,
      ],
    },
    route: {
      h: 'Die Strecke im Detail',
      paras: [
        `Auf der Strecke „${t}" bringen wir Sie direkt und ohne Umsteigen von Tür zu Tür. Das ist besonders angenehm mit viel Gepäck, spät in der Nacht, früh am Morgen oder wenn keine direkte Zugverbindung verfügbar ist. Ihr Chauffeur kennt die schnellsten und sichersten Routen.`,
        `Unterwegs geniessen Sie den Komfort eines privaten Fahrzeugs: klimatisiert, ruhig und mit genügend Platz zum Entspannen. Auf Wunsch legen wir einen kurzen Zwischenstopp ein oder holen weitere Mitreisende an einer zweiten Adresse ab.`,
      ],
    },
    ski: {
      h: 'Ski-Transfer in die Alpen',
      paras: [
        `Für „${t}" setzen wir Fahrzeuge mit ausreichend Platz für Ski, Snowboards und Winterausrüstung ein. Unsere Chauffeure sind mit den Bergstrassen im Winter vertraut und fahren mit passender Bereifung sicher in die beliebtesten Schweizer Skiorte wie Zermatt, St. Moritz, Verbier, Davos oder Andermatt.`,
        `Buchen Sie in der Hochsaison frühzeitig, da Transfers in den Wintermonaten schnell ausgebucht sind. Wir bringen Sie und Ihre Gruppe entspannt vom Flughafen direkt bis vor Ihr Chalet oder Hotel – ganz ohne Umsteigen mit schwerem Gepäck.`,
      ],
    },
    business: {
      h: 'Chauffeur- und Limousinenservice für Geschäftsreisen',
      paras: [
        `„${t}" richtet sich an Reisende, die Diskretion, Pünktlichkeit und Stil schätzen. Unsere Chauffeure sind professionell gekleidet, zurückhaltend und ermöglichen Ihnen, die Fahrtzeit produktiv zu nutzen oder sich vor dem nächsten Termin zu entspannen.`,
        `Für Firmen bieten wir stundenweise Buchungen, feste Ansprechpartner und ordentliche Rechnungen für Ihre Spesenabrechnung. Wählen Sie zwischen Mercedes E-Klasse, S-Klasse oder V-Klasse – je nach Anlass, Personenzahl und gewünschtem Komfort.`,
      ],
    },
  }[cat];

  const tail = [
    catSection,
    {
      h: 'Unsere Fahrzeugflotte',
      paras: [
        `Für jede Reise das passende Fahrzeug: Die Economy-Klasse eignet sich ideal für bis zu drei Personen mit leichtem Gepäck. Die Business Class (Mercedes E-Klasse) bietet mehr Komfort für Geschäftsreisen, während die First Class (Mercedes S-Klasse) höchsten Anspruch und Diskretion erfüllt.`,
        `Reisen Sie in der Gruppe oder mit viel Gepäck, sind unser Business Van (Mercedes V-Klasse) für bis zu sieben Personen oder der Minibus die richtige Wahl. Alle Fahrzeuge sind neuwertig, klimatisiert, sauber und werden regelmässig gewartet.`,
      ],
    },
    {
      h: 'Praktische Reisetipps',
      paras: [
        `Geben Sie bei der Buchung Ihre Flugnummer an, damit wir Ihren Flug automatisch verfolgen können. Notieren Sie Sonderwünsche wie einen Kindersitz, zusätzlichen Gepäckraum oder eine bevorzugte Sprache Ihres Chauffeurs direkt im Buchungsformular.`,
        `Speichern Sie Ihre Buchungsreferenz und unsere Telefonnummer, damit Sie uns bei Bedarf schnell erreichen. Bei Gruppenreisen empfiehlt es sich, eine gemeinsame Abhol- und Zieladresse festzulegen, um den Ablauf so reibungslos wie möglich zu gestalten.`,
      ],
    },
    {
      h: 'Zuverlässig in der ganzen Schweiz',
      paras: [
        `CAB.TAXI ist nicht nur in Zürich, sondern in der ganzen Schweiz für Sie unterwegs. Von den grossen Flughäfen Zürich, Genf und Basel bringen wir Sie in jede Stadt, jedes Dorf und jeden Skiort – ob Luzern, Bern, Interlaken, Zermatt, St. Moritz, Davos oder Lugano. Auch abgelegene Bergorte erreichen wir zuverlässig, das ganze Jahr über.`,
        `Ebenso organisieren wir grenzüberschreitende Fahrten nach Liechtenstein, Süddeutschland, ins Elsass oder nach Norditalien. Sagen Sie uns einfach Ihr Ziel, und wir kümmern uns um den Rest – inklusive Grenzformalitäten und der besten Route.`,
      ],
    },
    {
      h: 'Sicherheit und Qualität',
      paras: [
        `Ihre Sicherheit hat für uns oberste Priorität. Alle Chauffeure sind lizenziert, erfahren und werden regelmässig geschult. Unsere Fahrzeuge werden sorgfältig gewartet, sind vollständig versichert und entsprechen den höchsten Schweizer Qualitätsstandards.`,
        `Über 6000 Reisende vertrauen jährlich auf unseren Service und bewerten uns mit durchschnittlich 4,8 von 5 Sternen. Diese Zuverlässigkeit ist der Grund, warum viele Privatgäste und Firmen immer wieder mit CAB.TAXI buchen und uns gerne weiterempfehlen.`,
      ],
    },
    {
      h: 'Zahlung, Stornierung und Support',
      paras: [
        `Sie bezahlen bequem bar beim Chauffeur oder per Kreditkarte. Eine Stornierung ist bis 24 Stunden vor Fahrtbeginn kostenlos möglich. Unser Kundenservice ist rund um die Uhr erreichbar und hilft Ihnen bei Änderungen, Sonderwünschen oder kurzfristigen Anpassungen.`,
      ],
    },
  ];

  const faqs = [
    { q: `Wie buche ich „${t}"?`, a: 'Geben Sie Abhol- und Zieladresse, Datum und Uhrzeit ein, wählen Sie Ihr Fahrzeug und bestätigen Sie die Buchung. Sie erhalten sofort eine Bestätigung mit Referenznummer.' },
    { q: 'Was passiert, wenn mein Flug Verspätung hat?', a: 'Wir verfolgen Ihren Flug in Echtzeit und passen die Abholung automatisch an. Es fallen keine zusätzlichen Kosten an.' },
    { q: 'Gibt es einen Nacht- oder Feiertagszuschlag?', a: 'Nein. Unser Festpreis gilt Tag und Nacht, an Wochenenden und Feiertagen – ohne versteckte Zuschläge.' },
    { q: 'Kann ich einen Kindersitz anfordern?', a: 'Ja, Kindersitze und Sitzerhöhungen stellen wir kostenlos zur Verfügung. Bitte geben Sie den Bedarf bei der Buchung an.' },
    { q: 'Wie kann ich bezahlen?', a: 'Bar beim Chauffeur oder per Kreditkarte. Auf Wunsch stellen wir eine Rechnung für Geschäftskunden aus.' },
  ];

  return { sections: [...base, ...tail], faqs, labels: { toc: 'Inhalt', faq: 'Häufige Fragen', min: 'Min. Lesezeit' } };
};

/* ---------------- English ---------------- */
const en = (t, cat) => {
  const base = [
    {
      h: 'Why booking in advance pays off',
      paras: [
        `If you are planning "${t}", booking in advance offers several advantages. You lock in a guaranteed fixed price that you already know before the ride — regardless of traffic, the time of day or waiting time at the airport. There are no surprises at the end of the trip and no scramble to find a free taxi at the terminal.`,
        `With an advance booking we assign you an experienced chauffeur who knows the region, keeps an eye on your flight and is ready on time. Especially in high season, on weekends or during peak hours, this is the difference between relaxed travel and long waiting.`,
      ],
    },
    {
      h: 'What the fixed price includes',
      paras: [
        `Our fixed price is genuinely all-inclusive. It covers a professional, local chauffeur, a modern and well-kept vehicle, automatic flight tracking, free waiting time, meet & greet with a name sign in the arrivals hall as well as complimentary water and WiFi on board. A child seat is available free of charge on request.`,
        `There are no hidden surcharges for night rides, public holidays or extra luggage. The price you see when booking is the price you pay — transparent and fair. For a return journey you can conveniently book both legs in one step.`,
      ],
    },
    {
      h: 'How prices are calculated',
      paras: [
        `The price for "${t}" is made up of a base fare and a distance-based kilometre rate. Depending on the vehicle class you choose — from a comfortable economy sedan to a luxurious Mercedes S-Class or a spacious van — the tariff varies. Larger vehicles with more room for passengers and luggage cost a little more.`,
        `For longer journeys into the mountains or to other cantons, a private transfer is particularly worthwhile because you reach your destination directly, without changing vehicles or waiting. Use our online calculator to get the exact fixed price for your route in seconds.`,
      ],
    },
  ];

  const catSection = {
    airport: {
      h: 'Arrival and pickup at Zurich Airport',
      paras: [
        `After landing, simply follow the signs to the arrivals hall, where your chauffeur will be waiting with a name sign — you do not have to worry about anything. If your flight is delayed, we automatically adjust the pickup thanks to real-time flight tracking, at no extra cost.`,
        `For the trip back to the airport we calculate the ideal pickup time based on your departure time and the current traffic situation so you reach check-in relaxed and on time. We recommend arriving about two hours before European flights and three hours before intercontinental flights.`,
      ],
    },
    route: {
      h: 'The route in detail',
      paras: [
        `On the "${t}" route we take you directly and without changing, door to door. This is especially pleasant with lots of luggage, late at night, early in the morning or when no direct train connection is available. Your chauffeur knows the fastest and safest routes.`,
        `Along the way you enjoy the comfort of a private vehicle: air-conditioned, quiet and with plenty of room to relax. On request we make a short stop or pick up additional travellers at a second address.`,
      ],
    },
    ski: {
      h: 'Ski transfers to the Alps',
      paras: [
        `For "${t}" we use vehicles with ample space for skis, snowboards and winter gear. Our chauffeurs are familiar with mountain roads in winter and drive safely with proper tyres to the most popular Swiss ski resorts such as Zermatt, St. Moritz, Verbier, Davos or Andermatt.`,
        `Book early in high season, as transfers sell out quickly during the winter months. We take you and your group comfortably from the airport right to your chalet or hotel — without changing vehicles with heavy luggage.`,
      ],
    },
    business: {
      h: 'Chauffeur and limousine service for business trips',
      paras: [
        `"${t}" is aimed at travellers who value discretion, punctuality and style. Our chauffeurs are professionally dressed and unobtrusive, allowing you to use the travel time productively or relax before your next appointment.`,
        `For companies we offer hourly bookings, dedicated contacts and proper invoices for your expense reports. Choose between the Mercedes E-Class, S-Class or V-Class — depending on the occasion, number of people and desired comfort.`,
      ],
    },
  }[cat];

  const tail = [
    catSection,
    {
      h: 'Our vehicle fleet',
      paras: [
        `There is a suitable vehicle for every journey: the economy class is ideal for up to three people with light luggage. The Business Class (Mercedes E-Class) offers more comfort for business travel, while First Class (Mercedes S-Class) meets the highest standards and discretion.`,
        `If you are travelling in a group or with a lot of luggage, our Business Van (Mercedes V-Class) for up to seven people or the minibus is the right choice. All vehicles are nearly new, air-conditioned, clean and serviced regularly.`,
      ],
    },
    {
      h: 'Practical travel tips',
      paras: [
        `Provide your flight number when booking so we can track your flight automatically. Note any special requests — such as a child seat, extra luggage space or a preferred chauffeur language — directly in the booking form.`,
        `Save your booking reference and our phone number so you can reach us quickly if needed. For group trips it helps to agree on a single pickup and destination address to keep everything running smoothly.`,
      ],
    },
    {
      h: 'Reliable throughout Switzerland',
      paras: [
        `CAB.TAXI serves not only Zurich but the whole of Switzerland. From the major airports of Zurich, Geneva and Basel we take you to every city, village and ski resort — whether Lucerne, Bern, Interlaken, Zermatt, St. Moritz, Davos or Lugano. We reach even remote mountain villages reliably, all year round.`,
        `We also arrange cross-border trips to Liechtenstein, southern Germany, Alsace or northern Italy. Simply tell us your destination and we take care of the rest — including border formalities and the best route.`,
      ],
    },
    {
      h: 'Safety and quality',
      paras: [
        `Your safety is our top priority. All chauffeurs are licensed, experienced and regularly trained. Our vehicles are carefully maintained, fully insured and meet the highest Swiss quality standards.`,
        `More than 6000 travellers rely on our service every year and rate us with an average of 4.8 out of 5 stars. This reliability is why many private guests and companies book with CAB.TAXI again and again and gladly recommend us.`,
      ],
    },
    {
      h: 'Payment, cancellation and support',
      paras: [
        `You can pay conveniently in cash to the chauffeur or by credit card. Cancellation is free of charge up to 24 hours before departure. Our customer service is available around the clock and helps you with changes, special requests or last-minute adjustments.`,
      ],
    },
  ];

  const faqs = [
    { q: `How do I book "${t}"?`, a: 'Enter the pickup and destination address, date and time, choose your vehicle and confirm the booking. You immediately receive a confirmation with a reference number.' },
    { q: 'What happens if my flight is delayed?', a: 'We track your flight in real time and adjust the pickup automatically. No additional costs apply.' },
    { q: 'Is there a night or holiday surcharge?', a: 'No. Our fixed price applies day and night, on weekends and public holidays — with no hidden surcharges.' },
    { q: 'Can I request a child seat?', a: 'Yes, child seats and boosters are provided free of charge. Please indicate your need when booking.' },
    { q: 'How can I pay?', a: 'In cash to the chauffeur or by credit card. On request we issue an invoice for business customers.' },
  ];

  return { sections: [...base, ...tail], faqs, labels: { toc: 'Contents', faq: 'Frequently asked questions', min: 'min read' } };
};

/* ---------------- French ---------------- */
const fr = (t, cat) => {
  const base = [
    {
      h: 'Pourquoi réserver à l\'avance est avantageux',
      paras: [
        `Si vous planifiez « ${t} », réserver à l'avance présente plusieurs avantages. Vous bloquez un prix fixe garanti, connu avant le trajet, quel que soit le trafic, l'heure ou le temps d'attente à l'aéroport. Aucune surprise à la fin de la course et pas de recherche stressante d'un taxi libre au terminal.`,
        `Avec une réservation anticipée, nous vous attribuons un chauffeur expérimenté qui connaît la région, surveille votre vol et se tient prêt à l'heure. En haute saison, le week-end ou aux heures de pointe, c'est la différence entre un voyage serein et une longue attente.`,
      ],
    },
    {
      h: 'Ce que comprend le prix fixe',
      paras: [
        `Notre prix fixe est réellement tout compris : un chauffeur professionnel local, un véhicule moderne et soigné, le suivi automatique des vols, le temps d'attente gratuit, l'accueil personnalisé avec pancarte dans le hall des arrivées, ainsi que l'eau et le WiFi à bord. Un siège enfant est disponible gratuitement sur demande.`,
        `Aucun supplément caché pour les trajets de nuit, les jours fériés ou les bagages supplémentaires. Le prix affiché à la réservation est celui que vous payez — transparent et équitable. Pour un aller-retour, vous réservez les deux trajets en une seule étape.`,
      ],
    },
    {
      h: 'Comment les prix sont calculés',
      paras: [
        `Le prix de « ${t} » se compose d'un tarif de base et d'un tarif au kilomètre selon la distance. Selon la classe de véhicule choisie — de la berline économique confortable à la luxueuse Mercedes Classe S ou au van spacieux — le tarif varie. Les véhicules plus grands coûtent un peu plus cher.`,
        `Pour les longs trajets vers la montagne ou d'autres cantons, le transfert privé est particulièrement avantageux car vous arrivez directement, sans correspondance ni attente. Utilisez notre calculateur en ligne pour obtenir le prix fixe exact en quelques secondes.`,
      ],
    },
  ];

  const catSection = {
    airport: {
      h: 'Arrivée et prise en charge à l\'aéroport de Zurich',
      paras: [
        `Après l'atterrissage, suivez simplement les panneaux vers le hall des arrivées où votre chauffeur vous attend avec une pancarte à votre nom. En cas de retard, nous ajustons automatiquement la prise en charge grâce au suivi des vols en temps réel, sans frais supplémentaires.`,
        `Pour le retour vers l'aéroport, nous calculons l'heure idéale de prise en charge selon votre heure de départ et le trafic, afin que vous arriviez détendu et à l'heure à l'enregistrement.`,
      ],
    },
    route: {
      h: 'Le trajet en détail',
      paras: [
        `Sur le trajet « ${t} », nous vous emmenons directement, sans correspondance, de porte à porte. C'est idéal avec beaucoup de bagages, tard le soir, tôt le matin ou sans train direct. Votre chauffeur connaît les itinéraires les plus rapides et les plus sûrs.`,
        `En chemin, vous profitez du confort d'un véhicule privé : climatisé, calme et spacieux. Sur demande, nous faisons un court arrêt ou récupérons d'autres voyageurs à une seconde adresse.`,
      ],
    },
    ski: {
      h: 'Transferts ski vers les Alpes',
      paras: [
        `Pour « ${t} », nous utilisons des véhicules avec suffisamment de place pour les skis, snowboards et équipements d'hiver. Nos chauffeurs connaissent les routes de montagne en hiver et conduisent en toute sécurité vers Zermatt, St-Moritz, Verbier, Davos ou Andermatt.`,
        `Réservez tôt en haute saison, car les transferts partent vite en hiver. Nous vous emmenons, vous et votre groupe, de l'aéroport jusqu'à votre chalet ou hôtel, sans changer de véhicule avec de lourds bagages.`,
      ],
    },
    business: {
      h: 'Service de chauffeur et de limousine pour les affaires',
      paras: [
        `« ${t} » s'adresse aux voyageurs qui apprécient la discrétion, la ponctualité et l'élégance. Nos chauffeurs sont habillés avec soin et discrets, vous permettant de travailler ou de vous détendre avant votre prochain rendez-vous.`,
        `Pour les entreprises, nous proposons des réservations à l'heure, des interlocuteurs dédiés et des factures pour vos notes de frais. Choisissez entre Mercedes Classe E, Classe S ou Classe V selon l'occasion.`,
      ],
    },
  }[cat];

  const tail = [
    catSection,
    {
      h: 'Notre flotte de véhicules',
      paras: [
        `Un véhicule adapté à chaque voyage : la classe économique convient pour trois personnes avec bagages légers. La Business Class (Mercedes Classe E) offre plus de confort, tandis que la First Class (Mercedes Classe S) répond aux plus hautes exigences.`,
        `Pour les groupes ou beaucoup de bagages, notre Business Van (Mercedes Classe V) pour sept personnes ou le minibus est le bon choix. Tous nos véhicules sont récents, climatisés, propres et entretenus régulièrement.`,
      ],
    },
    {
      h: 'Conseils pratiques',
      paras: [
        `Indiquez votre numéro de vol à la réservation pour que nous puissions le suivre automatiquement. Notez vos demandes spéciales — siège enfant, espace bagages supplémentaire ou langue du chauffeur — directement dans le formulaire.`,
        `Conservez votre référence de réservation et notre numéro de téléphone pour nous joindre rapidement si nécessaire.`,
      ],
    },
    {
      h: 'Fiable dans toute la Suisse',
      paras: [
        `CAB.TAXI dessert non seulement Zurich mais toute la Suisse. Depuis les grands aéroports de Zurich, Genève et Bâle, nous vous emmenons dans chaque ville, village et station de ski — Lucerne, Berne, Interlaken, Zermatt, St-Moritz, Davos ou Lugano. Nous atteignons même les villages de montagne isolés, toute l'année.`,
        `Nous organisons également des trajets transfrontaliers vers le Liechtenstein, le sud de l'Allemagne, l'Alsace ou le nord de l'Italie. Indiquez-nous simplement votre destination et nous nous occupons du reste, formalités et meilleur itinéraire compris.`,
      ],
    },
    {
      h: 'Sécurité et qualité',
      paras: [
        `Votre sécurité est notre priorité. Tous nos chauffeurs sont licenciés, expérimentés et régulièrement formés. Nos véhicules sont soigneusement entretenus, entièrement assurés et répondent aux normes de qualité suisses les plus élevées.`,
        `Plus de 6000 voyageurs font confiance à notre service chaque année et nous attribuent en moyenne 4,8 étoiles sur 5. Cette fiabilité explique pourquoi de nombreux clients et entreprises réservent régulièrement avec CAB.TAXI et nous recommandent.`,
      ],
    },
    {
      h: 'Paiement, annulation et assistance',
      paras: [
        `Vous payez en espèces au chauffeur ou par carte de crédit. L'annulation est gratuite jusqu'à 24 heures avant le départ. Notre service client est disponible 24h/24 pour toute modification ou demande.`,
      ],
    },
  ];

  const faqs = [
    { q: `Comment réserver « ${t} » ?`, a: 'Saisissez l\'adresse de prise en charge et de destination, la date et l\'heure, choisissez votre véhicule et confirmez. Vous recevez immédiatement une confirmation avec numéro de référence.' },
    { q: 'Que se passe-t-il si mon vol est retardé ?', a: 'Nous suivons votre vol en temps réel et ajustons la prise en charge automatiquement, sans frais.' },
    { q: 'Y a-t-il un supplément de nuit ?', a: 'Non. Notre prix fixe s\'applique jour et nuit, week-ends et jours fériés compris.' },
    { q: 'Puis-je demander un siège enfant ?', a: 'Oui, gratuitement. Merci de l\'indiquer à la réservation.' },
    { q: 'Comment payer ?', a: 'En espèces au chauffeur ou par carte de crédit. Facture sur demande pour les professionnels.' },
  ];

  return { sections: [...base, ...tail], faqs, labels: { toc: 'Sommaire', faq: 'Questions fréquentes', min: 'min de lecture' } };
};

/* ---------------- Italian ---------------- */
const it = (t, cat) => {
  const base = [
    {
      h: 'Perché conviene prenotare in anticipo',
      paras: [
        `Se stai pianificando « ${t} », prenotare in anticipo offre diversi vantaggi. Blocchi un prezzo fisso garantito, noto prima del viaggio, indipendentemente dal traffico, dall'ora o dall'attesa in aeroporto. Nessuna sorpresa a fine corsa e nessuna ricerca affannosa di un taxi libero al terminal.`,
        `Con la prenotazione anticipata ti assegniamo un autista esperto che conosce la regione, monitora il tuo volo ed è pronto in orario. In alta stagione, nei weekend o nelle ore di punta fa la differenza tra un viaggio sereno e una lunga attesa.`,
      ],
    },
    {
      h: 'Cosa include il prezzo fisso',
      paras: [
        `Il nostro prezzo fisso è davvero tutto compreso: un autista professionista del posto, un veicolo moderno e curato, il monitoraggio automatico dei voli, il tempo di attesa gratuito, l'accoglienza con cartello nella hall degli arrivi, oltre ad acqua e WiFi a bordo. Un seggiolino è disponibile gratuitamente su richiesta.`,
        `Nessun supplemento nascosto per corse notturne, festivi o bagagli extra. Il prezzo mostrato in fase di prenotazione è quello che paghi — trasparente ed equo. Per l'andata e ritorno prenoti entrambe le tratte in un unico passaggio.`,
      ],
    },
    {
      h: 'Come si calcolano i prezzi',
      paras: [
        `Il prezzo di « ${t} » è composto da una tariffa base e da una tariffa al chilometro in base alla distanza. A seconda della classe scelta — dalla comoda berlina economica alla lussuosa Mercedes Classe S o al van spazioso — la tariffa varia. I veicoli più grandi costano un po' di più.`,
        `Per i tragitti lunghi verso la montagna o altri cantoni, il transfer privato è particolarmente conveniente perché arrivi direttamente, senza cambi né attese. Usa il nostro calcolatore online per ottenere il prezzo fisso esatto in pochi secondi.`,
      ],
    },
  ];

  const catSection = {
    airport: {
      h: 'Arrivo e ritiro all\'aeroporto di Zurigo',
      paras: [
        `Dopo l'atterraggio segui le indicazioni per la hall degli arrivi, dove il tuo autista ti aspetta con un cartello. In caso di ritardo adeguiamo automaticamente il ritiro grazie al monitoraggio dei voli in tempo reale, senza costi aggiuntivi.`,
        `Per il ritorno in aeroporto calcoliamo l'orario di ritiro ideale in base al tuo volo e al traffico, così arrivi al check-in rilassato e puntuale.`,
      ],
    },
    route: {
      h: 'Il tragitto nel dettaglio',
      paras: [
        `Sulla tratta « ${t} » ti portiamo direttamente, senza cambi, porta a porta. È l'ideale con molti bagagli, a tarda notte, la mattina presto o senza treno diretto. Il tuo autista conosce i percorsi più rapidi e sicuri.`,
        `Lungo il tragitto godi del comfort di un veicolo privato: climatizzato, silenzioso e spazioso. Su richiesta facciamo una breve sosta o ritiriamo altri passeggeri a un secondo indirizzo.`,
      ],
    },
    ski: {
      h: 'Transfer sci verso le Alpi',
      paras: [
        `Per « ${t} » usiamo veicoli con spazio sufficiente per sci, snowboard e attrezzatura invernale. I nostri autisti conoscono le strade di montagna in inverno e guidano in sicurezza verso Zermatt, St. Moritz, Verbier, Davos o Andermatt.`,
        `Prenota in anticipo in alta stagione, perché i transfer si esauriscono in fretta. Portiamo te e il tuo gruppo dall'aeroporto fino allo chalet o all'hotel, senza cambiare veicolo con bagagli pesanti.`,
      ],
    },
    business: {
      h: 'Servizio con autista e limousine per lavoro',
      paras: [
        `« ${t} » è pensato per chi apprezza discrezione, puntualità e stile. I nostri autisti sono vestiti con cura e discreti, permettendoti di lavorare o rilassarti prima del prossimo appuntamento.`,
        `Per le aziende offriamo prenotazioni a ore, referenti dedicati e fatture per le note spese. Scegli tra Mercedes Classe E, Classe S o Classe V a seconda dell'occasione.`,
      ],
    },
  }[cat];

  const tail = [
    catSection,
    {
      h: 'La nostra flotta',
      paras: [
        `Un veicolo adatto a ogni viaggio: la classe economica è ideale per tre persone con bagaglio leggero. La Business Class (Mercedes Classe E) offre più comfort, mentre la First Class (Mercedes Classe S) soddisfa le massime esigenze.`,
        `Per gruppi o molti bagagli, il nostro Business Van (Mercedes Classe V) per sette persone o il minibus è la scelta giusta. Tutti i veicoli sono recenti, climatizzati, puliti e sottoposti a manutenzione regolare.`,
      ],
    },
    {
      h: 'Consigli pratici',
      paras: [
        `Indica il numero del volo in fase di prenotazione così da poterlo monitorare automaticamente. Annota richieste speciali — seggiolino, spazio bagagli extra o lingua dell'autista — direttamente nel modulo.`,
        `Conserva il numero di riferimento della prenotazione e il nostro numero di telefono per contattarci rapidamente se necessario.`,
      ],
    },
    {
      h: 'Affidabile in tutta la Svizzera',
      paras: [
        `CAB.TAXI serve non solo Zurigo ma tutta la Svizzera. Dai principali aeroporti di Zurigo, Ginevra e Basilea ti portiamo in ogni città, paese e località sciistica — Lucerna, Berna, Interlaken, Zermatt, St. Moritz, Davos o Lugano. Raggiungiamo in modo affidabile anche i villaggi di montagna più remoti, tutto l'anno.`,
        `Organizziamo inoltre viaggi transfrontalieri verso Liechtenstein, Germania meridionale, Alsazia o Italia settentrionale. Indicaci semplicemente la destinazione e pensiamo a tutto noi, comprese le formalità di confine e il percorso migliore.`,
      ],
    },
    {
      h: 'Sicurezza e qualità',
      paras: [
        `La tua sicurezza è la nostra priorità. Tutti gli autisti sono autorizzati, esperti e formati regolarmente. I nostri veicoli sono curati con attenzione, completamente assicurati e rispettano i più elevati standard di qualità svizzeri.`,
        `Ogni anno oltre 6000 viaggiatori si affidano al nostro servizio e ci valutano con una media di 4,8 stelle su 5. Questa affidabilità è il motivo per cui molti clienti privati e aziende prenotano di nuovo con CAB.TAXI e ci raccomandano volentieri.`,
      ],
    },
    {
      h: 'Pagamento, cancellazione e assistenza',
      paras: [
        `Paghi comodamente in contanti all'autista o con carta di credito. La cancellazione è gratuita fino a 24 ore prima della partenza. Il nostro servizio clienti è disponibile 24 ore su 24 per modifiche o richieste.`,
      ],
    },
  ];

  const faqs = [
    { q: `Come prenoto « ${t} »?`, a: 'Inserisci indirizzo di ritiro e destinazione, data e ora, scegli il veicolo e conferma. Ricevi subito una conferma con numero di riferimento.' },
    { q: 'Cosa succede se il volo è in ritardo?', a: 'Monitoriamo il volo in tempo reale e adeguiamo il ritiro automaticamente, senza costi.' },
    { q: 'C\'è un supplemento notturno?', a: 'No. Il prezzo fisso vale giorno e notte, weekend e festivi inclusi.' },
    { q: 'Posso richiedere un seggiolino?', a: 'Sì, gratuitamente. Indicalo in fase di prenotazione.' },
    { q: 'Come posso pagare?', a: 'In contanti all\'autista o con carta di credito. Fattura su richiesta per aziende.' },
  ];

  return { sections: [...base, ...tail], faqs, labels: { toc: 'Indice', faq: 'Domande frequenti', min: 'min di lettura' } };
};

const BUILDERS = { de, en, fr, it };

// Generic builder reused by both blog articles and guide/section pages.
export const buildSections = (title, cat, lang) => {
  const builder = BUILDERS[lang] || BUILDERS.en;
  const safeCat = ['airport', 'route', 'ski', 'business'].includes(cat) ? cat : 'airport';
  return builder(title, safeCat);
};

export const buildArticle = (post, lang) => {
  const loc = post[lang] || post.en;
  const title = loc.title;
  const cat = categoryOf(post);
  const builder = BUILDERS[lang] || BUILDERS.en;
  const { sections, faqs, labels } = builder(title, cat);
  const intro = loc.body || [];
  const words = intro.join(' ').split(/\s+/).length + wordCount(sections)
    + faqs.reduce((n, f) => n + (f.q + ' ' + f.a).split(/\s+/).length, 0);
  const readMin = Math.max(3, Math.round(words / 200));
  return { intro, sections, faqs, labels, readMin, words };
};
